import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

const list = [
  {
    id: 'CO',
    value: 'Comunicazione Ostativa',
  },
  {
    id: 'CP',
    value: 'Chiusura Positiva',
  },
  {
    id: 'CN',
    value: 'Chiusura Negativa',
  },
];

interface TypeCommunicationListProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label?: string;
}

const TypeCommunicationListComponent = ({
  disabled,
  onChange,
  value,
  error,
  label = 'Tipo Comunicazione',
}: TypeCommunicationListProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel id="type-communication-list-label">{label}</InputLabel>
      <PmiSelect
        labelId="type-communication-list-label"
        id="type-communication-list"
        name="type-communication-list"
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {(list as Array<ItemVM>)?.map((type: ItemVM) => (
          <MenuItem key={type.id} value={type.id}>
            {type.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

TypeCommunicationListComponent.displayName = 'type communication list component';

const TypeCommunicationList = memo(TypeCommunicationListComponent);

export default TypeCommunicationList as typeof TypeCommunicationListComponent;
